<template>
  <div class="flex flex-1 flex-col items-center justify-center px-4">
    <div class="tablet-h:max-w-[550px] mx-auto max-w-[500px] text-center">
      <h1
        class="tablet-h:text-[44px] tablet-h:leading-[80px] tablet-h:tracking-[-0.61px] text-[32px] leading-[66px] font-medium tracking-[-0.44px] text-gray-800"
      >
        Page not found
      </h1>
      <p
        class="tablet-h:text-[22px] tablet-h:leading-[26px] mt-5 text-[20px] leading-[24px] font-medium text-gray-800"
      >
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>
      <p
        class="tablet-h:text-[17px] tablet-h:leading-[26px] mt-[30px] text-[16px] leading-[22px] text-gray-800"
      >
        Visit the <RouterLink to="/" class="text-link">homepage</RouterLink> or
        contact
        <a href="https://help.dacr.com" target="_blank" class="text-link"
          >support</a
        >.
      </p>
    </div>
  </div>
</template>
